import { inject, Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { FeatureFlagState } from '../../store/feature-flag';
import { FeatureFlag } from '../models/feature-flag.model';

@Injectable({
    providedIn: 'root'
})
export class FeatureGuard implements CanActivate {
    private router = inject(Router);
    private store = inject(Store);

    public canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
        const feature: string = route.data['feature'];

        return this.store.select(FeatureFlagState.flags).pipe(
            filter((value) => !!value),
            take(1),
            map((flags: FeatureFlag) => {
                const isEnabled = feature && flags?.[feature]?.enabled;

                return isEnabled ? true : this.router.createUrlTree(['/unauthorized']);
            })
        );
    }
}
